module.exports = __webpack_public_path__ + "media/dashboard/assets/images/business_manager_empty-3dc901cc117ce4d484934bcd7bd1f0bd.svg";